import { render } from "./AppointmentSummary.vue?vue&type=template&id=3f6dc95e&scoped=true"
import script from "./AppointmentSummary.vue?vue&type=script&lang=js"
export * from "./AppointmentSummary.vue?vue&type=script&lang=js"

import "./AppointmentSummary.vue?vue&type=style&index=0&id=3f6dc95e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f6dc95e"]])

export default __exports__